import { observer } from 'mobx-react'
import { useContext } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'

import { UserStoreContext } from '@/stores/UserStore'

/**
 * PublicRoute
 *
 * If a user is authenticated and attempts to access the component, they will be
 * redirected to their main page
 */
const PublicRoute = observer(() => {
  const { isAuthenticated } = useContext(UserStoreContext)
  const location = useLocation()

  // An invitation link opened while signed in must reach the set-password
  // page, which offers linking the invitation to the current account
  // (RSCX-351) — bouncing to the dashboard would silently drop the token.
  const claimingInvitation =
    location.pathname === '/set-password' && new URLSearchParams(location.search).has('token')

  return isAuthenticated && !claimingInvitation ? (
    <Navigate
      to={{
        pathname: location.state?.from || '/accounts',
      }}
    />
  ) : (
    <Outlet />
  )
})

export default PublicRoute
